exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui-grid-pager-control input{width:auto}.ui-grid-pager-row-count-picker select{padding:0}.ui-dialog-content{overflow:scroll}.spinnerpanel{padding-right:1rem}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaPagingGrid/src/components/lbaPagingGrid/lbaPagingGrid.scss"],"names":[],"mappings":"AAAA,6BACI,UAAW,CACd,uCAGG,SAAY,CACf,mBAEG,eAAgB,CAEnB,cAEG,kBAAmB,CACtB","file":"lbaPagingGrid.scss","sourcesContent":[".ui-grid-pager-control input {\r\n    width: auto;\r\n}\r\n\r\n.ui-grid-pager-row-count-picker select {\r\n    padding: 0px;\r\n}\r\n.ui-dialog-content{\r\n    overflow: scroll;\r\n    \r\n}\r\n.spinnerpanel{\r\n    padding-right: 1rem;\r\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sass-loader?sourceMap!./src/components/lbaPagingGrid/lbaPagingGrid.scss
// module id = 406
// module chunks = 0